
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePermissions } from '@/contexts/unified-permissions';
import { isIOSNativeApp } from '@/utils/platformUtils';

const EntryRoute: React.FC = () => {
  // React hooks must be called at the top level
  const { isAuthenticated } = usePermissions();
  const location = useLocation();

  try {



    // If authenticated, go to journal regardless of platform
    if (isAuthenticated) {
      return <Navigate to="/journal" replace />;
    }

    // For unauthenticated users, route based on platform
    // iOS native app users go to welcome page, web users go to landing page
    const isIOSNative = isIOSNativeApp();
    const redirectPath = isIOSNative ? '/welcome' : '/landing';



    // Preserve query parameters when redirecting
    const searchParams = location.search;
    const fullRedirectPath = searchParams ? `${redirectPath}${searchParams}` : redirectPath;



    return <Navigate to={fullRedirectPath} replace />;

  } catch (error) {
    console.error('🚨 EntryRoute CRASHED:', error);
    console.error('🚨 EntryRoute CRASHED - Stack:', error instanceof Error ? error.stack : 'No stack');
    // Fallback to landing page if something goes wrong
    return <Navigate to="/landing" replace />;
  }
};

export default EntryRoute;
